import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import {  AllocationSheetsServiceProxy, AllocationSheetStatus, GetStaffAndUserListViewDto, PagedResultDtoOfResourceAllocationListDto, ResourceAllocationDateWiseListDto, ResourceAllocationDetailDto, ResourceAllocationDto, StaffRoleType, StaffsAndUsersServiceProxy } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { WidgetComponentBaseComponent } from '../widget-component-base';
import { takeUntil } from '@node_modules/rxjs/operators';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '@shared/helpers/CustomDateAdapter';

@Component({
  selector: 'app-widget-supervisor-submissions-by-day',
  templateUrl: './widget-supervisor-submissions-by-day.component.html',
  styleUrls: ['./widget-supervisor-submissions-by-day.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ],
})

  export class WidgetSupervisorSubmissionsByDayComponent extends WidgetComponentBaseComponent
  implements OnInit, OnDestroy {
    selectedDateRange: moment.Moment[] = [
        this.getWeekStartDate(new Date().setDate(new Date().getDate())),
        this.getWeekEndDate(new Date().setDate(new Date().getDate()))
    ];

  clicktimes:number=0;
  filterText: any;
  cols: any[];
  endDate: moment.Moment;
  startDate: moment.Moment;
  projectId:any;
  resourceAllocationList: PagedResultDtoOfResourceAllocationListDto;
  maxcount:number=0;
  allocations:any[] = [];
  names: any[];
  private _managers: any[];
  public get managers(): any[] {
    return this._managers;
  }
  public set managers(value: any[]) {
    this._managers = value;
  }
  status: any[];
  delegationSupervisor: GetStaffAndUserListViewDto;
  supervisorList: GetStaffAndUserListViewDto[] = [];
  allocationSheetStatus = AllocationSheetStatus;
  enumKeys=[];
  nameFilterIsActive: boolean;
  managerFilterIsActive: boolean;
  statusFilterIsActive: boolean;
  statusSelection:any;
  filterNameShow: String;
  filterNameIsSingle: boolean;
  public nameFormCtrl: FormControl = new FormControl();
  public nameFilterFormCtrl: FormControl = new FormControl();
  public filteredName: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public managerFormCtrl: FormControl = new FormControl();
  public managerFilterFormCtrl: FormControl = new FormControl();
  public filteredManager: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public statusFormCtrl: FormControl = new FormControl();
  public statusFilterFormCtrl: FormControl = new FormControl();
  public filteredStatus: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  resourceAllocationDto: ResourceAllocationDto;
  constructor(injector: Injector,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private _sessionService: AppSessionService,
    private _projectService:ProjectService,
    private _fileDownloadService: FileDownloadService) {
    super(injector);
  }


  async ngOnInit() {
    this.projectId = await this._projectService.getCurrentOrDefaultProjectId();
    this.startDate =this.selectedDateRange[0];
    this.endDate = this.selectedDateRange[1];
    this.cols = [];
    // this.subDateRangeFilter();
    this.runDelayed(()=>this.GetResourceAllocationList());

    const editData = forkJoin({
      names: this._allocationSheetsServiceProxy
      .getStaffByStaticRole(this._sessionService.defaultSupervisorRoleId),
      managers: this._allocationSheetsServiceProxy
      .getStaffByStaticRole(this._sessionService.defaultForemanRoleId)
  });

  editData.subscribe((data) => {
      this.filteredName.next(data.names.slice());
      this.filteredManager.next(data.managers.slice());
      this.names = data.names;
      this.managers = data.managers;

      for (const [propertyKey, propertyValue] of Object.entries(this.allocationSheetStatus)) {
        if (!Number.isNaN(Number(propertyKey))) {
          continue;
      }
      this.enumKeys.push({ id: propertyValue, name: "allocationEnum_"+propertyKey });
      this.filteredStatus.next(Object.values(this.enumKeys.slice()));
      this.status = this.enumKeys;
  }
  });
  this.initiateFiltersValueChanges();
  }

  GetPrevWeek(){
    var current_start_date = this.startDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_start_date))).setDate((current_start_date).getDate() - 1)),
      this.getWeekEndDate((new Date(current_start_date)).setDate((current_start_date).getDate() - 1)),
     ]);
  }

   GetNextWeek(){
    var current_end_date = this.endDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_end_date))).setDate((current_end_date).getDate() + 1)),
      this.getWeekEndDate((new Date(current_end_date)).setDate((current_end_date).getDate() + 1)),
     ]);
  }

  private initiateFiltersValueChanges() {
    this.nameFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterNames();
        });

    this.managerFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterManagers();
        });

    this.statusFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterStatus();
        });
}
 filterNames() {
  if (!this.names) {
      return;
  }
  let search = this.nameFilterFormCtrl.value;
  if (!search) {
      this.filteredName.next(this.names.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredName.next(
      this.names?.filter(
          (param) => param.staffUser.firstName.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterManagers() {
  if (!this.managers) {
      return;
  }

  let search = this.managerFilterFormCtrl.value;
  if (!search) {
      this.filteredManager.next(this.managers.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredManager.next(
      this.managers?.filter(
        (mgr) => mgr.staffUser.firstName.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterStatus() {
  if (!this.status) {
      return;
  }

  let search = this.statusFilterFormCtrl.value;
  if (!search) {
      this.filteredStatus.next(this.status.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredStatus.next(
      this.status?.filter(
          (status) => status.name.toLowerCase().indexOf(search) > -1
      )
  );
}

  subDateRangeFilter() {
    abp.event.on(
      'app.dashboardFilters.dateRangePicker.onDateChange',
      this.onDateRangeFilterChange
    );
  }

  onDateRangeFilterChange = (dateRange) => {
    if (
      !dateRange ||
      dateRange.length !== 2 ||
      (this.selectedDateRange[0] === dateRange[0] &&
        this.selectedDateRange[1] === dateRange[1])
    ) {
      return;
    }
    this.startDate=dateRange[0];
    this.endDate =dateRange[1]
    this.GetResourceAllocationList();
  };

  GetResourceAllocationList = (nameFilter:number[]=null,managerFilter:number[]=null,statusFilter:number[]=null) => {
    this.primengTableHelper.showLoadingIndicator();

    this._allocationSheetsServiceProxy.getResourceAllocationList(this.startDate,this.endDate,nameFilter,managerFilter,statusFilter,null,0,200).pipe(finalize(() => this.primengTableHelper.hideLoadingIndicator()))
      .subscribe((result) => {
        this.resourceAllocationList = result;
        this.resourceAllocationList.items.forEach((item)=>(this.maxcount=item.resourceAllocationDateWiseListDtos.length>this.maxcount?item.resourceAllocationDateWiseListDtos.length:this.maxcount));
        this.primengTableHelper.totalRecordsCount = result.items.length;
        this.primengTableHelper.records = result.items;
        this.primengTableHelper.hideLoadingIndicator();
        this.ConvertObjectToarray(result,this.startDate.toDate(),this.endDate.toDate());
        this.createTableColums(this.startDate.toDate(),this.endDate.toDate());
      });
  }

  ExportData = (type:string) => {

    let managerFilter =[];
    let nameFilter =[];
    let statusFilter=[];

  const params = {
          filterText: this.filterText,
          name: this.nameFormCtrl.value || null,
          manager: this.managerFormCtrl.value || null,
          status: this.statusFormCtrl.value || null,
      };
      if(params.manager!=null)
      {
        params.manager.forEach((element: { staffUser: { staffId: any; }; }) => {
          managerFilter.push(element.staffUser.staffId);
        });
      }
      if(params.name!=null)
      {
        params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
          nameFilter.push(element.staffUser.staffId);
        });
      }

      if(params.status!=null)
      {
        params.status.forEach((element: { id: any; }) => {
          statusFilter.push(element.id);
        });
      }



    if(type==='xlsx')
{
    this._allocationSheetsServiceProxy.getResourceAllocationListExportToExcel(this.startDate, this.endDate, nameFilter, managerFilter, statusFilter,null,0,200)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
    if(type==='csv'){

      this._allocationSheetsServiceProxy.getResourceAllocationListExportToCSV(this.startDate, this.endDate, nameFilter, managerFilter, statusFilter,null,0,200)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
  }

  createTableColums(startDate:Date,endDate:Date)
  {
    this.cols=[];
    let dateIterator=new Date(startDate);
    for (dateIterator = startDate; endDate >= dateIterator; dateIterator.setDate(dateIterator.getDate() + 1)) {
      this.cols.push({ field: new Date(dateIterator), header: new Date(dateIterator) });
    }
  }

  ConvertObjectToarray(resourceAllocationListDto:PagedResultDtoOfResourceAllocationListDto,startDate:Date,endDate:Date)
  {
    this.allocations=[];
    for (let i = 0; i < resourceAllocationListDto.items.length; i++)
    {
      let entityallocationForResource={
                                        staffId:resourceAllocationListDto.items[i].staffId,
                                        firstName : resourceAllocationListDto.items[i].firstName,
                                        lastName : resourceAllocationListDto.items[i].lastName,
                                        staffRole :resourceAllocationListDto.items[i].staffRole,
                                        resourceAllocationDetails:[],
                                      }

      let resourceAllocationDetail=resourceAllocationListDto.items[i].resourceAllocationDateWiseListDtos;
      const start = new Date(startDate);
      let loop = new Date(start);
      for (var d = loop; endDate >= d; d.setDate(d.getDate() + 1))
      {
       let found=false;
        for (let j =  0; j < resourceAllocationDetail.length; j++)
        {
          let workdate=resourceAllocationDetail[j].workDate.toDate();
          if(d.getTime()===workdate.getTime())
          {
          entityallocationForResource.resourceAllocationDetails.push(resourceAllocationDetail[j]);
          found=true;
          break;
          }
        }
        if(!found)
        {
          let obj = new ResourceAllocationDateWiseListDto();
          obj.activityCount=0;
          entityallocationForResource.resourceAllocationDetails.push(obj);
        }
      }
      this.allocations.push(entityallocationForResource);
    }
  }
  ConvertObjectToarrayForMatTable(resourceAllocationListDto:PagedResultDtoOfResourceAllocationListDto,startDate:Date,endDate:Date)
  {
    this.allocations=[];
    for (let i = 0; i < resourceAllocationListDto.items.length; i++)
    {
       let entityallocationForResource={
                                        staffId:resourceAllocationListDto.items[i].staffId,
                                        firstName : resourceAllocationListDto.items[i].firstName,
                                        lastName : resourceAllocationListDto.items[i].lastName,
                                        staffRole :resourceAllocationListDto.items[i].staffRole,
                                        // staffRoleName: resourceAllocationListDto.items[i].staffRoleName,
                                        resourceAllocationDetails:[],
                                      }

      let resourceAllocationDetail=resourceAllocationListDto.items[i].resourceAllocationDateWiseListDtos;
      let d=new Date(startDate);
      for (d = startDate; endDate >= d; d.setDate(d.getDate() + 1))
      {
       let found=false;
        for (let j =  0; j < resourceAllocationDetail.length; j++)
        {
          let workdate=resourceAllocationDetail[j].workDate.toDate();
          if(d.getTime()===workdate.getTime())
          {
          entityallocationForResource.resourceAllocationDetails.push(resourceAllocationDetail[j]);
          found=true;
          break;
          }
        }
        if(!found)
        {
          let obj = new ResourceAllocationDetailDto();
          entityallocationForResource.resourceAllocationDetails.push(obj);
        }
      }
      this.allocations.push(entityallocationForResource);
    }
  }
  refresh() {
    this.filtersChange();
  }

clear() {
    this.filterText = null;
    this.nameFormCtrl.reset();
    this.managerFormCtrl.reset();
    this.statusFormCtrl.reset();
    this.filtersChange();
    this.managerFilterIsActive = false
    this.nameFilterIsActive = false
    this.statusFilterIsActive = false
}


getWeekEndDate(date): moment.Moment {
    const inputDate = new Date(date);
    const nextWeekStartDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) )));
    const nextWeekEndDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay() + 7 )));
    return this.formatDate(nextWeekEndDate);
  }

  formatDate(date):moment.Moment {
    const currentDate = moment(date);
    currentDate.format('DD/MM/YY');
    return currentDate;
  }

  formatDateForReport(date) {
    return new Date(date).setHours(0,0,0,0);
  }

  getWeekStartDate(date) {
    const inputDate = new Date(date);
    const nextWeekStartDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) )));
    return this.formatDate(nextWeekStartDate);
  }

  onDateSelected(event) {
    var dateString = event.targetElement.value;
    var dateParts = dateString.split("/");
    var jsDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    this.onDateRangeFilterChange([
      this.getWeekStartDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())),
      this.getWeekEndDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())),
     ]);
  }

  GetThisWeek(){
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date())).setDate((new Date()).getDate())),
      this.getWeekEndDate((new Date()).setDate((new Date()).getDate())),
     ]);
  }

exportData(type:string)
{
  this.ExportData(type);
}

filtersChange() {
  let managerFilter =[];
  let nameFilter =[];
  let statusFilter=[];

const params = {
        filterText: this.filterText,
        name: this.nameFormCtrl.value || null,
        manager: this.managerFormCtrl.value || null,
        status: this.statusFormCtrl.value || null,
    };
    if(params.manager!=null)
    {
      params.manager.forEach((element: { staffUser: { staffId: any; }; }) => {
        managerFilter.push(element.staffUser.staffId);
      });
      if(params.manager.length > 0) {
        this.managerFilterIsActive = true
      } else {
        this.managerFilterIsActive = false
      }
    }
    if(params.name!=null)
    {
      params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
        nameFilter.push(element.staffUser.staffId);
      });
      if(params.name.length > 0) {
        this.nameFilterIsActive = true
      } else {
        this.nameFilterIsActive = false
      }
    }

    if(params.status!=null)
    {
      params.status.forEach((element: { id: any; }) => {
        statusFilter.push(element.id);
      });
      if(params.status.length > 0) {
        this.statusFilterIsActive = true
      } else {
        this.statusFilterIsActive = false
      }
    }

    if(params.manager != null && params.manager.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.manager[0].staffUser.userName;
        this.filterNameIsSingle = true;
    } else if(params.name != null && params.name.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.name[0].staffUser.userName;
        this.filterNameIsSingle = true;
    } else if(params.status != null && params.status.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = this.l(params.status[0].name);
        this.filterNameIsSingle = true;
    } else if(params.manager != null && params.manager.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.name != null && params.name.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.status != null && params.status.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.manager != null && params.manager.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.manager != null && params.manager.length > 0 && params.status != null && params.status.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.status != null && params.status.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else {
        this.filterNameShow = ""
        this.filterNameIsSingle = false;
    }

    this.GetResourceAllocationList(nameFilter,managerFilter,statusFilter);
}

async GetResourceAllocationDetails(resourceAllocationDateWiseListDto:ResourceAllocationDateWiseListDto,resourceAllocationDat:any){
  abp.event.trigger('app.evt.opensubmissionDetailPanel', {
    projectId: this.projectId,
    workDate:resourceAllocationDateWiseListDto.workDate,
    staffId:resourceAllocationDat.staffId,
    firstName:resourceAllocationDat.firstName,
    lastName:resourceAllocationDat.lastName,
    staffRole:resourceAllocationDat.staffRole,
    staffRoleName:resourceAllocationDat.staffRoleName
  });
  }
}
